// @flow

import React from 'react';
import { createRefetchContainer, graphql } from 'react-relay';
import { withRouter } from 'react-router-dom';
import { DataGrid } from '../ui/data-grid/data-grid';
// material-ui
import TextField from 'material-ui/TextField';
import FlatButton from 'material-ui/FlatButton';
import ContentAdd from 'material-ui/svg-icons/content/add';
import IconRefresh from 'material-ui/svg-icons/av/replay';

import ArticleListItem from './ArticleListItem';

// Отображение скрытых
import ShowHiddenElement from '../showHiddenElement/index';
// Pagination
import Pagination from '../controls/pagination/pagination';
//
import { sectionPath } from '../../lib/config';
// style
import '../ui/wrapper.css';
import '../ui/table.css';
import '../ui/paper.css';
import { styles } from '../../lib/styles';
import './articles.css';

type Props = {
	history: Object,
	location: Object,
	match: Object,
	relay: Object,
	router: Object,
	viewer: Object,
};

type State = {
	currentQuery: ?string,
	pageCursor: number,
	searchText: ?string,
	section: string,
	states: Array<?string>,
	totalPages: number,
};

const columns = [
	{ title: 'Дата', className: 'articles-table--date' },
	{ title: 'Заголовок', className: 'articles-table--title' },
	{ title: 'Автор', className: 'articles-table--author' },
	{ title: 'Статус', className: 'articles-table--state' },
	{ title: 'Информация', className: 'articles-table--info' },
];

class ArticleList extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props);
		const pageNumber = this.props.location.hash ? parseInt(this.props.location.hash.replace('#', ''), 10) : 1;
		this.state = {
			section: props.match.params.section,
			searchText: '',
			states: ['available', 'draft'],
			pageCursor: pageNumber,
			currentQuery: '',
			totalPages: Math.ceil(this.props.viewer.articles.totalCount / 12),
		};
	}

	componentWillReceiveProps(nextProps: Object) {
		this.setState({ totalPages: Math.ceil(nextProps.viewer.articles.totalCount / 12) });
	}

	changePageUrl = (path: number) => {
		this.props.history.replace(`/articles/${this.state.section}?page#${path}`);
	};

	createArticle = (): void => {
		this.props.history.push(`/articles/${this.state.section}/new`);
	};

	refreshPage = (): void => {
		window.location = window.location;
	};

	changePage = (pageNumber: number) => {
		const refetchVars = fragmentVars => ({
			page: pageNumber,
			section: fragmentVars.section,
			search: this.state.currentQuery ? this.state.currentQuery : null,
		});

		this.props.relay.refetch(refetchVars, null, () => {
			this.setState({ pageCursor: pageNumber });
		});
		this.changePageUrl(pageNumber);
	};

	searchFieldKeyPressed = (e: Object) => {
		if (e.charCode !== 13) {
			return;
		}

		const refetchVars = fragmentVars => ({
			page: 1,
			states: this.state.states,
			section: fragmentVars.section,
			search: this.state.searchText && this.state.searchText.length > 0 ? this.state.searchText : null,
		});

		this.props.relay.refetch(refetchVars, null, () => {
			this.setState({
				pageCursor: 1,
				currentQuery: this.state.searchText && this.state.searchText.length > 0 ? this.state.searchText : null,
				searchText: '',
			});
		});
	};

	changeHiddenShow = (flag: boolean) => {
		const stringStatus = flag ? ['deleted'] : ['available', 'draft'];
		const vars = () => ({
			page: 1,
			states: stringStatus,
			search: this.state.currentQuery ? this.state.currentQuery : null,
		});

		this.props.relay.refetch(vars, null, () => {
			this.setState({
				pageCursor: 1,
				states: stringStatus,
				currentQuery: this.state.searchText && this.state.searchText.length > 0 ? this.state.searchText : null,
				searchText: '',
			});
		});
	};

	render() {
		const sectionName = this.state.section === sectionPath.news ? 'Новости' : 'Статьи';
		const btnTitle = this.state.section === sectionPath.news ? 'Создать новость' : 'Создать статью';
		const { currentQuery } = this.state;
		const items = this.props.viewer.articles.articles;
		return (
			<section className="wrapper">
				<div className="paper-wrapper">
					<section className="paper paper_main articles">
						<header className="paper-header articles-header">
							<h3 className="articles-header--title">
								{sectionName}
								{!!currentQuery && currentQuery.length > 0 ? `(${currentQuery})` : ''}
							</h3>
							<div className="articles-controls--search">
								<TextField
									hintText="Поиск"
									value={this.state.searchText}
									onKeyPress={e => this.searchFieldKeyPressed(e)}
									onChange={(e, v) => this.setState({ searchText: v })}
								/>
							</div>
							<div className="articles-controls--buttons">
								<ShowHiddenElement onClick={this.changeHiddenShow} />
								<FlatButton
									label="Обновить"
									style={styles.headerButton}
									primary
									icon={<IconRefresh />}
									onClick={this.refreshPage}
									labelStyle={{ paddingLeft: 6, paddingRight: 18 }}
								/>
								<FlatButton
									label={btnTitle}
									style={{ ...styles.headerButton, marginLeft: 8 }}
									primary
									icon={<ContentAdd />}
									onClick={this.createArticle}
									labelStyle={{ paddingLeft: 6, paddingRight: 18 }}
								/>
							</div>
						</header>
						<section className="articles-list">
							<DataGrid columns={columns} items={items}>
								{items.map(edge => (
									<ArticleListItem
										columns={columns}
										key={edge.__id}
										article={edge}
										router={this.props.router}
										viewer={this.props.viewer}
									/>
								))}
							</DataGrid>
						</section>
					</section>
					<footer className="articles-footer">
						<Pagination totalPage={this.state.totalPages} currentPage={this.state.pageCursor} changePage={e => this.changePage(e)} />
					</footer>
				</div>
			</section>
		);
	}
}

export default withRouter(
	createRefetchContainer(
		ArticleList,
		graphql`
			fragment ArticleList_viewer on Viewer
				@argumentDefinitions(
					page: { type: "Int!" }
					search: { type: "String" }
					blockSlug: { type: "String" }
					section: { type: "ID!" }
					states: { type: "[ArticleStateType]" }
				) {
				configurableBlock(slug: $blockSlug) {
					id
					type
					slug
					config
					active
				}
				articles: articlesPaginate(pageSize: 12, page: $page, plainSearch: $search, section: $section, states: $states) {
					totalCount
					articles {
						...ArticleListItem_article
					}
				}
			}
		`,
		graphql`
			query ArticleList_Refetch_Query($page: Int!, $blockSlug: String!, $section: ID!, $search: String, $states: [ArticleStateType]) {
				viewer {
					...ArticleList_viewer @arguments(page: $page, blockSlug: $blockSlug, search: $search, section: $section, states: $states)
				}
			}
		`,
	),
);



// WEBPACK FOOTER //
// src/components/articles/ArticleList.js